import axios from "axios";
import { API_BASE_URL } from "./config";

const apiIntercepteur = axios.create({
  baseURL: `${API_BASE_URL}`,
  timeout: 15000, // abandonne la requête après une attente prolongée
});

const SLOW_CONNECTION_TIMEOUT = 5000;

const dispatchConnectionWarning = (message) => {
  window.dispatchEvent(
    new CustomEvent("api:slow-connection", { detail: message })
  );
};

const notifySlowConnection = (config) => {
  config.slowConnectionTimer = setTimeout(() => {
    dispatchConnectionWarning(
      "Votre connexion internet est lente ou instable, veuillez la vérifier."
    );
  }, SLOW_CONNECTION_TIMEOUT);

  return config;
};

const clearSlowConnectionNotification = (responseOrError) => {
  const config = responseOrError?.config;
  if (config?.slowConnectionTimer) {
    clearTimeout(config.slowConnectionTimer);
    delete config.slowConnectionTimer;
  }
};

const handleResponseError = (error) => {
  clearSlowConnectionNotification(error);

  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  // Pas de réponse (timeout, connexion lente ou coupée) : on prévient
  // l'utilisateur sans le rediriger, le serveur n'est pas forcément en cause
  if (!error.response) {
    dispatchConnectionWarning(
      "Impossible de joindre le serveur, veuillez vérifier votre connexion internet."
    );
    return Promise.reject(error);
  }

  // Seules les réponses d'erreur du serveur mènent à la page de maintenance
  const status = error.response.status;
  if (status >= 500 && status < 600 && window.location.pathname !== "/maintenance") {
    console.log("Serveur indisponible, redirection...");
    window.location.href = "/maintenance";
  }

  return Promise.reject(error);
};

const handleResponse = (response) => {
  clearSlowConnectionNotification(response);
  return response;
};

apiIntercepteur.interceptors.request.use(notifySlowConnection);
apiIntercepteur.interceptors.response.use(handleResponse, handleResponseError);
axios.defaults.timeout = 15000;
axios.interceptors.request.use(notifySlowConnection);
axios.interceptors.response.use(handleResponse, handleResponseError);

export default apiIntercepteur;
